
<div class="row solid-section">
    <div class="col-12 event__video">
        <div *ngIf="block.videoData.desc; then thenBlock else elseBlock"></div>
        <ng-template #thenBlock>
            <div [id]="id" class="row px-0 mx-0">
                <div class="col-12 col-md-6 right">
                    <div>
                        <div class="title" [innerHTML]="block.blockTitle"></div>
                        <app-read-more *ngIf="block.videoData.desc" 
                            [text]="block.videoData.desc" 
                            [classes]="descClasses"
                            [textColor]="eventPageConfig.customColorTheme.videoColors.videoSectionTextColor"
                            [options]="options"
                        ></app-read-more>
                    </div>
                </div>
                <div class="col-12 col-md-6 video left">
                    <div class="d-block w-100">
                        <div class="video-wrapper align-center">
                            <iframe [src]="videoUrl" class="video-container align-center w-100 h-100"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template #elseBlock>
            <div [id]="id" class="row px-0">
                <div class="col-12 right video-only">
                    <div class="title" [innerHTML]="block.blockTitle"></div>
                </div>
                <div class="col-12 left video-only">
                    <div class="video-wrapper">
                        <iframe [src]="videoUrl" class="video-container-full align-center h-100"></iframe>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
  </div>